import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { SimpleListAdapter, TS_DropDown } from '@nu-art/thunderstorm-frontend/index';
import { actionSubTypeLabelMap, ActionSubTypes_Order } from '@app/pathway-shared';
import { DropDown_DefaultCaret } from '@app/styles/frontend/ui/consts';
const subTypes = ActionSubTypes_Order;
const adapter = SimpleListAdapter([...subTypes], type => _jsx(_Fragment, { children: actionSubTypeLabelMap[type.item] }));
const mandatoryProps_SubTypeDropdown = {
    adapter: adapter,
    caret: DropDown_DefaultCaret,
    placeholder: 'Choose type'
};
export const Dropdown_Subtype = TS_DropDown.prepareEditable(mandatoryProps_SubTypeDropdown);
//# sourceMappingURL=DropDown_Subtype.js.map